module.exports = __webpack_public_path__ + "static/media/tutoriales_scrum.96614fb2.svg";